import React from 'react';
import logo from '../projectitems/arth2.png';
import sentraLogo from '../projectitems/sentralogoo.png';

const Footer = () => {
    const scrollTo = (id) => {
        if (id === '#') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        const el = document.querySelector(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <footer className="footer">
            <div className="footer__top">
                <div className="footer__brand">
                    <button className="logo logo-btn" onClick={() => scrollTo('#')}>
                        <img src={logo} alt="ARTH YAPI" className="logo__image" />
                        <div className="logo__text">
                            <span className="logo__name">ARTH</span>
                            <span className="logo__sub">YAPI</span>
                        </div>
                    </button>
                    <p className="footer__tagline">
                        Mekanlarınıza estetik, fonksiyonel ve özgün çözümler sunuyoruz.
                    </p>
                    <div className="footer__social">
                        <a href="https://www.instagram.com/arthyapi/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                            </svg>
                        </a>
                    </div>
                </div>

                <div className="footer__links">
                    <div className="footer__col">
                        <h4 className="footer__col-title">Sayfalar</h4>
                        {[
                            { label: 'Anasayfa', href: '#' },
                            { label: 'Hakkımızda', href: '#terra' },
                            { label: 'Hizmetlerimiz', href: '#magaza' },
                            { label: 'Projelerimiz', href: '#uygulamalar' },
                            { label: 'Ürünlerimiz', href: '#urunler' },
                            { label: 'Makinelerimiz', href: '#makineler' },
                            { label: 'Neden Biz', href: '#hizmetler' },
                            { label: 'İletişim', href: '#iletisim' },
                        ].map((l) => (
                            <button key={l.label} className="footer__link" onClick={() => scrollTo(l.href)}>
                                {l.label}
                            </button>
                        ))}
                    </div>
                    <div className="footer__col">
                        <h4 className="footer__col-title">Yasal</h4>
                        {[
                            'KVKK Aydınlatma Metni',
                            'Üyelik Sözleşmesi',
                            'Mesafeli Satış Sözleşmesi',
                            'İptal ve İade Şartları',
                            'Gizlilik ve Güvenlik',
                        ].map((l) => (
                            <button key={l} className="footer__link">{l}</button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <p>© 2026 by Arth Yapı. Tüm Hakları Saklıdır.</p>
                <a
                    href="https://sentracoding.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__credit"
                >
                    <span>Designed by</span>
                    <img src={sentraLogo} alt="Sentra Coding" className="footer__credit-logo" />
                    <span>Sentra Coding</span>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
